var e=function(e,o){return void 0===o&&(o=""),"".concat(e,"/").concat(o.replace("&","").replace(/\s+/g,"-").toLowerCase(),"-jobs")};export{e as getCatTagPageLink};
//# sourceMappingURL=link.js.map
